import {
  fetchActivity,
} from './home-page.service';

export default {
  namespaced: true,
  state: {
    profileActivity: {},
  },
  mutations: {
    setProfileActivity: (state, activity) => {
      state.profileActivity = activity;
    },
  },
  actions: {
    async fetchActivity({ dispatch, commit }, params) {
      try {
        const data = await fetchActivity(params);
        commit('setProfileActivity', data);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Failed to fetch activity', error }, { root: true });
      }
    },
  },
};
